<div class="dashboard-page-conatiner">
  <!-- <ssg-page-header></ssg-page-header> -->
  <div class="dashboard--container">
    <!-- <router-outlet></router-outlet> -->
     <app-dashboard></app-dashboard>
  </div>
  <!-- <ssg-page-footer></ssg-page-footer> -->
</div>
